import { CommonDevelopmentSettings } from './common-development-settings';
import { CommonSettings } from './common-settings';

export type AppNames = 'mobile' | 'admin' | 'student' | 'gabby';

export class EnvironmentTemplate {
	public static staticEnvironment: EnvironmentTemplate = null;

	public production: boolean;
	public assets: string;
	public cdn: string;
	public settings: CommonSettings;

	constructor({
		production,
		assetRoot,
		cdnRoot,
	}: {
		production: boolean;
		assetRoot: string;
		cdnRoot: string;
	}) {
		this.production = production;
		this.assets = assetRoot;
		this.cdn = cdnRoot;
		this.setupSettings();

		if (EnvironmentTemplate.staticEnvironment != null) {
			throw new Error(
				'EnvironmentTemplate.staticEnvironment has already been set',
			);
		} else {
			EnvironmentTemplate.staticEnvironment = this;
		}

		window['ga_environment'] = EnvironmentTemplate.staticEnvironment;
	}

	protected setupSettings() {
		this.settings = this.production
			? new CommonSettings()
			: new CommonDevelopmentSettings();

		const ga_ng = (window['ga_ng'] ?? {}) as {
			settings?: Record<string, unknown>;
		};
		if (ga_ng.settings) {
			for (const [dotPath, value] of Object.entries(ga_ng.settings)) {
				const keys = dotPath.split('.');
				let target: object = this.settings;
				for (let i = 0; i < keys.length - 1; i++) {
					if (target[keys[i]] != null && typeof target[keys[i]] === 'object') {
						target = target[keys[i]];
					} else {
						target = null;
						break;
					}
				}
				if (target != null) {
					target[keys[keys.length - 1]] = value;
				}
			}
		}

		if (typeof ngDevMode !== 'undefined' && ngDevMode) {
			// eslint-disable-next-line no-restricted-globals
			const overrideSettings = sessionStorage.getItem(
				'environment_override_settings',
			);
			if (overrideSettings) {
				try {
					const overrideSettingsObj = JSON.parse(overrideSettings);
					console.warn(
						'Overriding environment settings with',
						overrideSettingsObj,
					);
					const deepAssign = (target: object, source: object): void => {
						for (const key of Object.keys(source)) {
							if (
								source[key] != null &&
								typeof source[key] === 'object' &&
								!Array.isArray(source[key]) &&
								target[key] != null &&
								typeof target[key] === 'object' &&
								!Array.isArray(target[key])
							) {
								deepAssign(target[key], source[key]);
							} else {
								target[key] = source[key];
							}
						}
					};
					deepAssign(this.settings, overrideSettingsObj);
				} catch (e) {
					console.error('Failed to parse environment override settings', e);
				}
			}
		}
	}

	public isApp(name: AppNames) {
		return name === window['angular_app_name'];
	}
}
